import { RecipientInfo } from './recipient-info.model';

export class RecipientSetInfo {
  privateMessage: string;
  recipientSetMemberInfos: RecipientInfo[];
  recipientSetName: string;
  recipientSetRole: string;

  constructor(info?: any) {
    info = info || {};
    this.privateMessage = info.privateMessage || null;
    this.recipientSetMemberInfos =
      info.recipientSetMemberInfos && info.recipientSetMemberInfos.length > 0
        ? info.recipientSetMemberInfos.map(recipientInfo => new RecipientInfo(recipientInfo))
        : [];
    this.recipientSetName = info.recipientSetName || null;
    this.recipientSetRole = info.recipientSetRole || null;
  }
}
